import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SingleFileUploads } from "../../../../Constant";
import CommonFileUpload from "../../../../Common/CommonFileUpload";
import { FILE_UPLOAD } from "../../../../Data/Bonus Ui/Dropzone";

const SingleFileUpload = () => {
  return (
    <Col lg="6">
      <Card className="m-2">
        <CommonCardHeader title={SingleFileUploads} span={FILE_UPLOAD} />
        <CommonFileUpload/>
      </Card>
    </Col>
  );
};

export default SingleFileUpload;
